const TEE_SPINNER_HTML =
  '<span class="tee-spinner tee-spinner--sm"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 128 128" class="tee-icon-loading tee-icon-loading--sm"><g><path d="M64 127.75A63.76 63.76 0 0152.8 1.23v14.23a49.8 49.8 0 1022.4 0V1.23A63.76 63.76 0 0164 127.75z"></path><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="1260ms" repeatCount="indefinite"></animateTransform></g></svg></span>';

function bindResetCustomizationModal(modal) {
  if (!modal || modal.dataset.bound === 'true') return;

  const closeButtons = modal.querySelectorAll('[data-close-modal]');
  const resetButtons = modal.querySelectorAll('[data-reset-modal]');
  const confirmButtons = modal.querySelectorAll('[data-confirm-reset]');

  const hideModal = () => {
    modal.style.display = 'none';
  };

  closeButtons.forEach((button) => {
    button.onclick = hideModal;
  });

  resetButtons.forEach((button) => {
    button.onclick = () => {
      button.disabled = true;
      button.innerHTML = TEE_SPINNER_HTML;
      window.teeinblue.resetCustomization(window.TeeInBlueCampaign.productId);
      hideModal();
    };
  });

  confirmButtons.forEach((button) => {
    button.onclick = () => {
      button.disabled = true;
      button.innerHTML = TEE_SPINNER_HTML;
      window.teeinblue.refillCustomization(window.TeeInBlueCampaign.productId);
      setTimeout(hideModal, 500);
    };
  });

  modal.dataset.bound = 'true';
}

function checkCustomizationModal() {
  if (!window.teeinblue || !window.TeeInBlueCampaign?.productId) return;

  const hasCustomization = window.teeinblue.hasCustomization(window.TeeInBlueCampaign.productId);
  const modal = document.getElementById('tee_reset_customization');

  if (!modal || !hasCustomization) return;

  bindResetCustomizationModal(modal);
  modal.style.display = 'block';
}

document.addEventListener('teeinblue-event-component-injected', checkCustomizationModal);
